import StatutoryComponents from "../Statutary/StatutoryComponents";

export default function LabourWelfareFundSettings() {
  return <StatutoryComponents forcedTab="lwf" />;
}
